require('./bootstrap');
const {reduce} = require("lodash/core");

// Enable touch events on mobile devices
document.body.addEventListener('touchstart', function () { }, { passive: true });

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(elem => new bootstrap.Tooltip(elem));

document.querySelectorAll('form').forEach((elem) => {
    elem.addEventListener('submit', (e) => {
        e.currentTarget.querySelectorAll('.btn-loading').forEach(elem => elem.disabled = 'true');
    });
});

window.confirmModal = (e) => {
    if (!confirm(e.currentTarget.dataset.confirm)) {
        e.preventDefault();
    }
}

document.querySelectorAll('[data-confirm]').forEach((elem) => {
    elem.addEventListener('click', window.confirmModal);
});

document.querySelectorAll('.copy-on-click').forEach((elem) => {
    elem.addEventListener('click', async (e) => {
        if (navigator.clipboard) {
            let target = e.target;
            await navigator.clipboard.writeText(target.dataset.copy || target.innerText);
        }
    });
});

document.querySelectorAll('.clickable').forEach((elem) => {
    elem.addEventListener('click', async (e) => {
        if (navigator.clipboard) {
            let target = e.target;
            await navigator.clipboard.writeText(target.dataset.copy || target.innerText);
            elem.className = 'clicked';
            setTimeout(async () => {
                elem.className = 'clickable';
            }, 2000);
        }
    });
});

let counter = (e) => {
    let target = e.currentTarget || e;
    document.getElementById(target.dataset.counter).innerText = (target.maxLength - target.value.length).toLocaleString();
};
document.querySelectorAll('.counter').forEach((elem) => {
    elem.addEventListener('keyup', counter);
    counter(elem);
});

document.querySelectorAll('[data-search-table]').forEach((elem) => {
    elem.addEventListener('keyup', (e) => {
        let input = e.currentTarget;
        let query = input.value.toLowerCase();
        let table = document.getElementById(input.dataset.searchTable);

        table.querySelectorAll('tbody tr').forEach((cell) => {
            if (cell.innerText.toLowerCase().indexOf(query) > -1) {
                cell.classList.remove('d-none');
            } else {
                cell.classList.add('d-none');
            }
        });
    });
});

const capitalize = s => s && s[0].toUpperCase() + s.slice(1)
const search_and_filter_list = (list_id) => {
    const list = document.getElementById(list_id);
    const searchInput = document.querySelector("[data-search='" + list_id + "']");
    const searchQuery = searchInput.value.toLowerCase();

    const filterQueries = [];
    document.querySelectorAll("[data-filter='" + list_id + "']").forEach((filterInput) => {
        filterQueries.push({
            category: filterInput.dataset.filterCategory,
            query: filterInput.value.toLowerCase(),
        })
    })

    const searchObj = reduce(filterQueries, function(map, query) {
        map[query.category] = query.query;
        return map;
    }, {
        search: searchQuery,
        list: list_id,
    });
    const searchParams = new URLSearchParams(searchObj);
    const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.replaceState(null, '', newRelativePathQuery);

    let count = 0;
    list.querySelectorAll('[data-search-value]').forEach((item) => {
        if (item.dataset.searchValue.indexOf(searchQuery) > -1 &&
            filterQueries.every(({ category, query }) => query === 'all' || item.dataset['filter' + capitalize(category) + 'Value'].indexOf(query) > -1)
        ) {
            item.classList.remove('d-none');
            count++;
        } else {
            item.classList.add('d-none');
        }
    });

    const counterText = document.querySelector("[data-result-counter='" + list_id + "']");
    if(counterText) {
        const counterTextMap = JSON.parse(counterText.getAttribute('data-result-counter-text'));
        counterText.innerHTML = counterTextMap[count] ?? counterTextMap['#'].replace('2', count.toString());
    }
}


function setSearchAndFilterValuesFromURL() {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const listId = urlSearchParams.get('list');
    if (!listId) {
        return;
    }

    // Set search value
    const searchValue = urlSearchParams.get('search');
    if (searchValue) {
        const searchInput = document.querySelector("[data-search='" + listId + "']");
        if (searchInput) {
            searchInput.value = searchValue;
        }
    }

    // Set filter values
    document.querySelectorAll("[data-filter='" + listId + "']").forEach((elem) => {
        const filterCategory = elem.dataset.filterCategory;
        const filterValue = urlSearchParams.get(filterCategory);
        if (filterValue) {
            elem.value = filterValue;
        }
    });

    search_and_filter_list(listId);
}



document.addEventListener('DOMContentLoaded', () => {
    // Read filter parameters from URL and set filter values
    setSearchAndFilterValuesFromURL();

    document.querySelectorAll('[data-search]').forEach((elem) => {
        elem.addEventListener('input', (e) => {
            search_and_filter_list(e.currentTarget.dataset.search);
        });
    });
    document.querySelectorAll('[data-filter]').forEach((elem) => {
        search_and_filter_list(elem.dataset.filter);
        elem.addEventListener('change', (e) => {
            search_and_filter_list(e.currentTarget.dataset.filter);
        });
    });
});


const markAll = document.getElementById('mark-all');
if (markAll) {
    markAll.addEventListener('click', () => {
        markAsRead().then(() => {
            document.getElementById('btn-notifications').classList.add('d-none');
            document.getElementById('btn-no-notifications').classList.remove('d-none');
        });
    });
}

const bgSection = document.querySelector('body > section.h-100');
document.querySelectorAll('.modal').forEach((modal) => {
    modal.addEventListener('show.bs.modal', () => bgSection.classList.add('blurred'));
    modal.addEventListener('hide.bs.modal', () => bgSection.classList.remove('blurred'));
});

window.markAsRead = function (id = null) {
    return axios.post('/notifications/read', {
        id: id,
    });
}

document.querySelectorAll('textarea.markdown-editor').forEach((textarea) => {
    const editor = new EasyMDE({
        element: textarea,
        autoDownloadFontAwesome: false,
        status: false,
        spellChecker: false,
        hideIcons: [
            'guide', 'code', 'table', 'image', 'quote',
        ],
        showIcons: [
            'strikethrough', 'horizontal-rule',
        ],
    });

    const counter = () => {
        document.getElementById(textarea.dataset.counter).innerText = (textarea.maxLength - editor.value().length).toLocaleString();
    };

    counter();
    editor.codemirror.on('change', counter);
})
